"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContractMainHeader = ContractMainHeader;
const react_1 = __importStar(require("react"));
const react_bootstrap_1 = require("react-bootstrap");
const react_hook_form_1 = require("react-hook-form");
const MainSetupReact_1 = __importDefault(require("../../../React/MainSetupReact"));
const ToolsDate_1 = __importDefault(require("../../../React/Tools/ToolsDate"));
const FormContext_1 = require("../../../View/Modals/FormContext");
const GeneralModalButtons_1 = require("../../../View/Modals/GeneralModalButtons");
const CommonComponents_1 = require("../../../View/Resultsets/CommonComponents");
const fidmanSyncService_1 = require("../Modals/fidmanSyncService");
const BussinesObjectSelectors_1 = require("../../../View/Modals/CommonFormComponents/BussinesObjectSelectors");
const ContractModalBodiesPartial_1 = require("../Modals/ContractModalBodiesPartial");
const ContractValidationSchema_1 = require("../Modals/ContractValidationSchema");
const ContractRowContent_1 = require("../ContractRowContent");
const ContractDetailsContext_1 = require("./ContractDetailsContext");
const ContractChatSpaceSection_1 = require("./ContractChatSpaceSection");
function ContractMainHeader() {
    const { contract, setContract, contractsRepository } = (0, ContractDetailsContext_1.useContractDetails)();
    if (!contract || !setContract)
        return react_1.default.createElement(react_bootstrap_1.Alert, { variant: "danger" }, "Nie wybrano umowy");
    if (!contractsRepository)
        return react_1.default.createElement(react_bootstrap_1.Alert, { variant: "danger" }, "Nie znaleziono repozytorium");
    // Brakująca data NIE zasłania już karty. Wcześniejsze trzy strażniki zwracały sam alert
    // zamiast całej góry umowy, przez co braku nie dało się nawet naprawić — modal edycji dat
    // otwiera się właśnie stąd. Nie były zresztą regułą domenową, tylko dopasowaniem do typu
    // `date: string` w DateEditTrigger; ten od zawsze umiał wyrenderować pusty termin.
    // Brak pokazujemy teraz w miejscu danej daty (decyzja właściciela 2026-08-11).
    function renderEntityDetails() {
        if (!contract)
            return react_1.default.createElement(react_1.default.Fragment, null);
        if ("ourId" in contract) {
            return (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("div", null, "Zamawiaj\u0105cy"),
                react_1.default.createElement("h5", null, renderEntityData(contract._employers || []))));
        }
        else
            return (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("div", null, "Wykonawca"),
                react_1.default.createElement("h5", null, renderEntityData(contract._contractors || []))));
    }
    function renderEntityData(entities) {
        return entities.map((entity) => {
            return (react_1.default.createElement("div", { key: entity.id },
                react_1.default.createElement("div", null, entity.name),
                react_1.default.createElement("div", null, entity.address),
                react_1.default.createElement("div", null, entity.taxNumber)));
        });
    }
    function handleEditObject(contract) {
        if (setContract)
            setContract(contract);
        const newItems = contractsRepository?.items.map((o) => (o.id === contract.id ? contract : o)) || [];
        if (contractsRepository)
            contractsRepository.items = newItems;
    }
    return (react_1.default.createElement(react_bootstrap_1.Container, null,
        react_1.default.createElement(react_bootstrap_1.Row, { className: "mt-3" },
            react_1.default.createElement(react_bootstrap_1.Col, { sm: 11, md: 6 }, renderEntityDetails()),
            "ourId" in contract && (react_1.default.createElement(react_bootstrap_1.Col, { sm: 4, md: 2 },
                react_1.default.createElement("div", null, "Oznaczenie:"),
                react_1.default.createElement("h5", null, contract.ourId))),
            react_1.default.createElement(react_bootstrap_1.Col, { sm: 4, md: 2 },
                react_1.default.createElement("div", null, "Nr umowy:"),
                react_1.default.createElement("h5", null, contract.number)),
            react_1.default.createElement(react_bootstrap_1.Col, { sm: 1 },
                react_1.default.createElement(GeneralModalButtons_1.PartialEditTrigger, { modalProps: {
                        initialData: contract,
                        modalTitle: "Edycja statusu",
                        repository: contractsRepository,
                        ModalBodyComponent: ContractModalBodiesPartial_1.ContractModalBodyStatus,
                        onEdit: handleEditObject,
                        fieldsToUpdate: ["status"],
                        makeValidationSchema: ContractValidationSchema_1.contractStatusValidationSchema,
                    } },
                    react_1.default.createElement(CommonComponents_1.ContractStatusBadge, { status: contract?.status }))),
            react_1.default.createElement(react_bootstrap_1.Col, { sm: 1 }, contract._gdFolderUrl && react_1.default.createElement(CommonComponents_1.GDFolderIconLink, { folderUrl: contract._gdFolderUrl })),
            react_1.default.createElement(react_bootstrap_1.Col, { sm: 12, md: 6, className: "d-flex align-items-center" },
                react_1.default.createElement(MoveContractButton, null)),
            react_1.default.createElement(react_bootstrap_1.Col, { sm: 12, md: 6, className: "d-flex flex-wrap align-items-center gap-2" },
                react_1.default.createElement(ContractChatSpaceSection_1.ContractChatSpaceSection, null),
                react_1.default.createElement(FidmanSyncSection, null),
                react_1.default.createElement(ContractDocumentSection, null)),
            react_1.default.createElement(react_bootstrap_1.Col, { sm: 12, md: 6 },
                react_1.default.createElement(GeneralModalButtons_1.PartialEditTrigger, { modalProps: {
                        initialData: contract,
                        modalTitle: "Edycja nazwy",
                        repository: contractsRepository,
                        ModalBodyComponent: ContractModalBodiesPartial_1.ContractModalBodyName,
                        onEdit: (contract) => {
                            setContract(contract);
                        },
                        fieldsToUpdate: ["name"],
                        makeValidationSchema: ContractValidationSchema_1.contractNameValidationSchema,
                    } },
                    react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement("div", null, "Nazwa:"),
                        react_1.default.createElement("h5", null, contract?.name)))),
            react_1.default.createElement(react_bootstrap_1.Col, { sm: 4, md: 2 },
                react_1.default.createElement("div", null, "Data podpisania:"),
                react_1.default.createElement(DateEditTrigger, { date: contract.startDate, isRequired: true })),
            react_1.default.createElement(react_bootstrap_1.Col, { sm: 4, md: 2 },
                react_1.default.createElement("div", null, "Termin zako\u0144czenia:"),
                react_1.default.createElement(DateEditTrigger, { date: contract.endDate, isRequired: true })),
            react_1.default.createElement(react_bootstrap_1.Col, { sm: 4, md: 2 },
                react_1.default.createElement("div", null, "Gwarancja:"),
                react_1.default.createElement(DateEditTrigger, { date: contract.guaranteeEndDate })),
            contract.warrantyEndDate && (react_1.default.createElement(react_bootstrap_1.Col, { sm: 4, md: 2 },
                react_1.default.createElement("div", null, "R\u0119kojmia:"),
                react_1.default.createElement(DateEditTrigger, { date: contract.warrantyEndDate }))),
            contract.defectsNotificationEndDate && (react_1.default.createElement(react_bootstrap_1.Col, { sm: 4, md: 2 },
                react_1.default.createElement("div", null, "Zg\u0142aszanie wad do:"),
                react_1.default.createElement(DateEditTrigger, { date: contract.defectsNotificationEndDate }))))));
}
function MoveContractButton() {
    const { contract, setContract, contractsRepository } = (0, ContractDetailsContext_1.useContractDetails)();
    const [show, setShow] = (0, react_1.useState)(false);
    const [isLoading, setIsLoading] = (0, react_1.useState)(false);
    const [error, setError] = (0, react_1.useState)(null);
    const methods = (0, react_hook_form_1.useForm)();
    const newProject = methods.watch("_newProject");
    if (!contract || !("ourId" in contract) || !setContract)
        return null;
    async function handleMove() {
        if (!newProject?.ourId || !setContract)
            return;
        setIsLoading(true);
        setError(null);
        try {
            const response = await fetch(`${MainSetupReact_1.default.serverUrl}contract/${contract.id}/move`, {
                method: "PUT",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ newProjectOurId: newProject.ourId }),
                credentials: "include",
            });
            if (!response.ok) {
                const msg = await response.text();
                throw new Error(msg || `Błąd serwera: ${response.status}`);
            }
            const updated = await response.json();
            setContract(updated);
            if (contractsRepository) {
                contractsRepository.items = contractsRepository.items.map((o) => o.id === updated.id ? updated : o);
            }
            setShow(false);
        }
        catch (err) {
            setError(err instanceof Error ? err.message : String(err));
        }
        finally {
            setIsLoading(false);
        }
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_bootstrap_1.Button, { variant: "outline-secondary", size: "sm", onClick: () => {
                methods.reset({ _newProject: undefined });
                setError(null);
                setShow(true);
            } }, "Przenie\u015B kontrakt"),
        react_1.default.createElement(react_bootstrap_1.Modal, { show: show, onHide: () => setShow(false) },
            react_1.default.createElement(react_bootstrap_1.Modal.Header, { closeButton: true },
                react_1.default.createElement(react_bootstrap_1.Modal.Title, null, "Przenie\u015B kontrakt do innego projektu")),
            react_1.default.createElement(react_bootstrap_1.Modal.Body, null,
                react_1.default.createElement(FormContext_1.FormProvider, { value: methods },
                    react_1.default.createElement(BussinesObjectSelectors_1.ProjectSelector, { name: "_newProject", showValidationInfo: false })),
                error && react_1.default.createElement(react_bootstrap_1.Alert, { variant: "danger", className: "mt-2" }, error)),
            react_1.default.createElement(react_bootstrap_1.Modal.Footer, null,
                react_1.default.createElement(react_bootstrap_1.Button, { variant: "secondary", onClick: () => setShow(false) }, "Anuluj"),
                react_1.default.createElement(react_bootstrap_1.Button, { variant: "primary", onClick: handleMove, disabled: !newProject?.ourId || isLoading }, isLoading ? react_1.default.createElement(react_bootstrap_1.Spinner, { size: "sm", animation: "border" }) : "Przenieś")))));
}
/**
 * SYNC-P2 — "synchronizacja do dopchnięcia" badge + manual retry for the
 * PS ENVI -> FIDman outbox (see ../Modals/fidmanSyncService.ts). Renders
 * nothing while status is "NONE" (contract type not synced, or not enqueued
 * yet) — the backend decides gating, the front just reflects it.
 */
function FidmanSyncSection() {
    const { contract } = (0, ContractDetailsContext_1.useContractDetails)();
    const [status, setStatus] = (0, react_1.useState)(null);
    const [isRetrying, setIsRetrying] = (0, react_1.useState)(false);
    const [error, setError] = (0, react_1.useState)(null);
    (0, react_1.useEffect)(() => {
        setStatus(null); // clear the previous contract's badge so it can't flash before the new fetch
        if (!contract?.id)
            return;
        let cancelled = false;
        (0, fidmanSyncService_1.fetchFidmanSyncStatus)(contract.id)
            .then((s) => {
            if (!cancelled)
                setStatus(s);
        })
            .catch(() => {
            // ponytail: silent — a missing/failed status read must not block the header.
        });
        return () => {
            cancelled = true;
        };
    }, [contract?.id]);
    if (!contract?.id || !status || status.status === "NONE")
        return null;
    async function handleRetry() {
        if (!contract?.id)
            return;
        setIsRetrying(true);
        setError(null);
        try {
            setStatus(await (0, fidmanSyncService_1.retryFidmanSync)(contract.id));
        }
        catch (err) {
            setError(err instanceof Error ? err.message : String(err));
        }
        finally {
            setIsRetrying(false);
        }
    }
    const canRetry = status.status === "FAILED" || status.status === "SKIPPED";
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(CommonComponents_1.FidmanSyncBadge, { status: status.status, tooltip: status.skipReasonLabel || status.lastError }),
        canRetry && (react_1.default.createElement(react_bootstrap_1.Button, { variant: "outline-secondary", size: "sm", onClick: handleRetry, disabled: isRetrying }, isRetrying ? react_1.default.createElement(react_bootstrap_1.Spinner, { size: "sm", animation: "border" }) : "Dopchnij synchronizację")),
        error && (react_1.default.createElement(react_bootstrap_1.Alert, { variant: "danger", className: "mb-0 py-1 px-2" }, error))));
}
/**
 * Wynik cyklicznej kontroli „czy wgrano umowę na Dysk". Ta sama plakietka co na liście —
 * jeden wygląd tego stanu w całej aplikacji.
 *
 * W karcie dokładamy DATĘ sprawdzenia, i to nie jest ozdobnik: bez niej użytkownik, który
 * właśnie wgrał umowę, widzi ostrzeżenie i nie ma jak się dowiedzieć, że pochodzi ono
 * z nocnego przebiegu, a nie z bieżącego stanu folderu.
 */
function ContractDocumentSection() {
    const { contract } = (0, ContractDetailsContext_1.useContractDetails)();
    if (!contract || contract._isContractDocumentMissing !== true)
        return null;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(ContractRowContent_1.ContractDocumentBadge, { contract: contract }),
        contract._contractDocumentCheckedAt && (react_1.default.createElement("span", { className: "text-muted small" },
            "sprawdzono ",
            ToolsDate_1.default.dateYMDtoDMY(contract._contractDocumentCheckedAt.slice(0, 10))))));
}
function DateEditTrigger({ date, isRequired }) {
    const { contract, setContract, contractsRepository } = (0, ContractDetailsContext_1.useContractDetails)();
    if (!contract || !setContract)
        return react_1.default.createElement(react_bootstrap_1.Alert, { variant: "danger" }, "Nie wybrano umowy");
    if (!contractsRepository)
        return react_1.default.createElement(react_bootstrap_1.Alert, { variant: "danger" }, "Nie znaleziono repozytorium");
    return (react_1.default.createElement(GeneralModalButtons_1.PartialEditTrigger, { modalProps: {
            initialData: contract,
            modalTitle: "Edycja dat",
            repository: contractsRepository,
            ModalBodyComponent: ContractModalBodiesPartial_1.ContractModalBodyDates,
            onEdit: (contract) => {
                setContract(contract);
            },
            fieldsToUpdate: [
                "startDate",
                "endDate",
                "guaranteeEndDate",
                "warrantyEndDate",
                "defectsNotificationEndDate",
            ],
            makeValidationSchema: ContractValidationSchema_1.contractDatesValidationSchema,
        } }, date ? (react_1.default.createElement("h5", null, ToolsDate_1.default.dateYMDtoDMY(date))) : (
    // Komunikat siedzi tam, gdzie stałaby data, i jest klikalny tak samo jak ona —
    // czyli jest zarazem informacją o braku i drogą do jego usunięcia.
    react_1.default.createElement("h5", { className: isRequired ? "text-danger" : "text-muted fst-italic" }, isRequired ? "Brak — uzupełnij" : "Jeszcze nie ustalono"))));
}
